import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  prefix?: string;
}
export function Accordion({
  title,
  children,
  prefix
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-xl bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset" data-id="element-3">
        <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3" data-id="element-4">
          {prefix && <span className="text-blue-600 font-bold text-sm uppercase tracking-wider" data-id="element-5">
              {prefix}
            </span>}
          <span className="font-bold text-slate-800 text-lg leading-tight" data-id="element-6">
            {title}
          </span>
        </div>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-7" />
      </button>
      <AnimatePresence data-id="element-8">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-9">
            <div className="px-6 pb-6 pt-2 text-slate-600 border-t border-slate-100" data-id="element-10">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}